import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
// import { toSelect } from 'utils/genericFunctions';
import { Types, AtualizarParametroLocalidadeDetalhe } from './types';

export const INITIAL_STATE: AtualizarParametroLocalidadeDetalhe = {
	status: 0,
	data: null,
	enum: [],
	totalRegistrosConsulta: 0,
};

export default function atualizarParametroLocalidadDetalheReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarParametroLocalidadeDetalhe {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data.localidades;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
	});
}
